<template>
  <svg
    width="6"
    height="44"
    viewBox="0 0 6 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.5 1.14233C3.5 0.866192 3.27614 0.642334 3 0.642334C2.72386 0.642334 2.5 0.866192 2.5 1.14233H3.5ZM0.333333 41.1423C0.333333 42.6151 1.52724 43.809 3 43.809C4.47276 43.809 5.66667 42.6151 5.66667 41.1423C5.66667 39.6696 4.47276 38.4757 3 38.4757C1.52724 38.4757 0.333333 39.6696 0.333333 41.1423ZM2.5 2.14233C2.5 2.41848 2.72386 2.64233 3 2.64233C3.27614 2.64233 3.5 2.41848 3.5 2.14233H2.5ZM3.5 8.14233C3.5 7.86619 3.27614 7.64233 3 7.64233C2.72386 7.64233 2.5 7.86619 2.5 8.14233H3.5ZM2.5 10.1423C2.5 10.4185 2.72386 10.6423 3 10.6423C3.27614 10.6423 3.5 10.4185 3.5 10.1423H2.5ZM3.5 16.1423C3.5 15.8662 3.27614 15.6423 3 15.6423C2.72386 15.6423 2.5 15.8662 2.5 16.1423H3.5ZM2.5 18.1423C2.5 18.4185 2.72386 18.6423 3 18.6423C3.27614 18.6423 3.5 18.4185 3.5 18.1423H2.5ZM3.5 24.1423C3.5 23.8662 3.27614 23.6423 3 23.6423C2.72386 23.6423 2.5 23.8662 2.5 24.1423H3.5ZM2.5 26.1423C2.5 26.4185 2.72386 26.6423 3 26.6423C3.27614 26.6423 3.5 26.4185 3.5 26.1423H2.5ZM3.5 32.1423C3.5 31.8662 3.27614 31.6423 3 31.6423C2.72386 31.6423 2.5 31.8662 2.5 32.1423H3.5ZM2.5 34.1423C2.5 34.4185 2.72386 34.6423 3 34.6423C3.27614 34.6423 3.5 34.4185 3.5 34.1423H2.5ZM3.5 40.1423C3.5 39.8662 3.27614 39.6423 3 39.6423C2.72386 39.6423 2.5 39.8662 2.5 40.1423H3.5ZM2.5 1.14233V2.14233H3.5V1.14233H2.5ZM2.5 8.14233V10.1423H3.5V8.14233H2.5ZM2.5 16.1423V18.1423H3.5V16.1423H2.5ZM2.5 24.1423V26.1423H3.5V24.1423H2.5ZM2.5 32.1423V34.1423H3.5V32.1423H2.5ZM2.5 40.1423V41.1423H3.5V40.1423H2.5Z" fill="url(#paint0_linear_2552_3313)" />
    <defs>
      <linearGradient
        id="paint0_linear_2552_3313"
        x1="3.5"
        y1="1.14233"
        x2="3.5"
        y2="41.1423"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E10019" stop-opacity="0" />
        <stop offset="1" stop-color="#E10019" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'AwCsrLine',
  };

</script>
